import { render } from "./CohortEight.vue?vue&type=template&id=ddf9522a"
import script from "./CohortEight.vue?vue&type=script&lang=js"
export * from "./CohortEight.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__